#import "../fragments/AutomationFlowListFields.graphql"

query AutomationFlowsList(
  $kinds: [AutomationKind!]!
  $status: AutomationStatus
  $search: String
  $page: Int
  $rowsPerPage: Int
) {
  automations(
    kinds: $kinds
    status: $status
    search: $search
    page: $page
    rowsPerPage: $rowsPerPage
  ) {
    nodes {
      ...AutomationFlowListFields
    }
    count
  }
}
